import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./components/App/App";
import reportWebVitals from "./reportWebVitals";
import Profile from "./components/Profile";
import CommentSection from "./components/CommentSection";
import Mapview from "./components/MapView";

const rootElement = document.getElementById("root")
let appTypeName = rootElement?.getAttribute("data-appType");
let appToRender;

if (appTypeName === "contribution") {
  let implementationId = rootElement.getAttribute("data-implementationId");
  let itemId = rootElement.getAttribute("data-itemId");
  appToRender = (
    <CommentSection
      implementationId={implementationId}
      itemId={itemId}
    />
  );
} else if (appTypeName === "profile") {
  let memberId = rootElement.getAttribute("data-memberId");
  let isCurrentOrganisation = rootElement.getAttribute("data-isCurrentOrganisation");
  let numberOfComments = parseInt(rootElement.getAttribute("data-numberOfComments"));
  appToRender = <Profile memberId={memberId} isCurrentOrganisation={isCurrentOrganisation} numberOfComments={numberOfComments}/>;
} else if (appTypeName === "mapview") {
  let implementationId = rootElement.getAttribute("data-implementationId");
  let campaignId = rootElement.getAttribute("data-campaignId");
  appToRender = <Mapview implementationId={implementationId} campaignId={campaignId}/>;
}

ReactDOM.render(
  <React.StrictMode>
    <App>{appToRender}</App>
  </React.StrictMode>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
